/* @flow */
// typecheck: ignore file
import React from 'react';
import Button from 'components/Button.jsx';
import Container from 'components/Container.jsx';
import EventTrackingConstants from 'payments/constants/EventTrackingConstants';
import TitleHeader from 'components/TitleHeader.jsx';
import Timestamp from 'components/Timestamp.jsx';
import Transaction from 'entities/Transaction';

type Props = {
  onComplete: () => void,
  transaction?: Transaction,
  onCompleteText?: string,
}

class DepositConfirmation extends React.Component {
  props: Props;

  static defaultProps = {
    onCompleteText: 'Got it',
  }

  render = () => {
    const subtext = this.props.transaction
      ? <span>The funds should arrive in your account: <Timestamp date={this.props.transaction.getAvailableAt()} /></span>
      : <span>The funds should arrive in your account in 1-2 business days</span>;

    return (
      <div className="DepositConfirmation">
        <Container size="medium">
          <TitleHeader
            image={require('assets/images/payments/DepositConfirmation/piggy-bank.svg')}
            title="Deposit complete"
            subtext={subtext}
            size="xlarge"
          />
          <Button
            onClick={this.props.onComplete}
            eventScreenName={EventTrackingConstants.DEPOSIT_RECEIPT}
            eventElementName="return_to_campaigns">
            {this.props.onCompleteText}
          </Button>
        </Container>
      </div>
    );
  }
}

export default DepositConfirmation;



// WEBPACK FOOTER //
// ./src/payments/components/DepositConfirmation.jsx